import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ImageCarousel({
  images = [],
  autoPlay = true,
  interval = 3500,
  showDots = true,
  showArrows = true,
  className = "",
}) {
  const settings = {
    dots: showDots,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: showArrows,
    autoplay: autoPlay,
    autoplaySpeed: interval,
 

     appendDots: dots => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "3px",      
        marginTop: "20px",
      }}
    >
      <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
    </div>
     ),
  };

  return (
    <div
      className={className}
      style={{ maxWidth: "600px", margin: "0 auto", marginBottom: "30px" }}
    >
       <style>
      {`
        .slick-dots li button:before {
          font-size: 10px !important;
        }
      `}
    </style>

      <Slider {...settings}>
        {images.map((img, idx) => (
          <div key={idx}>
            <img
              src={img.src}
              alt={img.alt || `Slide ${idx + 1}`}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
